import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import clarity from '@microsoft/clarity';
import {environment} from "./environments/environment";
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

clarity.init(environment.CLARITY);
const options = {
  init: {
    licenseKey: environment.licenseKey,
    applicationID: environment.applicationID,
    distributed_tracing: {
      enabled: true
    },
    spa: {
      enabled: true
    }
  },
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    applicationID:  environment.applicationID,
    licenseKey: environment.licenseKey,
    sa: 1
  },
  loader_config: {
    accountID: environment.accountID,
    trustKey: environment.trustKey,
    agentID: environment.agentID,
    licenseKey: environment.licenseKey,
    applicationID:  environment.applicationID
  }
};

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    new BrowserAgent(options);
  })
  .catch(err => console.error(err));
